/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { Provider } from '@angular/core';
import { provideState } from '@ngrx/store';
import { UiFeature } from './ui/ui.reducer';
import { UiService } from './ui/ui.service';

export function provideSharedCommon(): Provider[] | Provider {
  return [UiService, provideState(UiFeature)];
}
